import { graphql } from '@eluve/graphql.tada';

/**
 * Loads every user in a tenant with the fields needed for both bulk-bundle
 * flows (Migrate Default Bundle, Update by Specialty):
 *  - identity (name, email)
 *  - specialty (citext, free-form, may be null)
 *  - current default bundle id (for source-bundle filter + preview)
 *
 * Bulk dialogs filter the cohort client-side rather than running a parameterized
 * query per filter choice. Tenants are bounded ( ~tens to low hundreds of users)
 * so filtering in memory is cheaper than re-querying on every selector change.
 */
export const getTenantUsersForBulkBundleQuery = graphql(`
  query getTenantUsersForBulkBundle($tenantId: uuid!) {
    tenantsByPk(id: $tenantId) {
      __typename
      id
      name
      tenantUsers {
        __typename
        tenantId
        userId
        user {
          __typename
          id
          firstName
          lastName
          email
          specialty
        }
        settings {
          __typename
          tenantId
          userId
          defaultTemplateBundleId
        }
      }
    }
  }
`);
